<template>
    <v-row no-gutters>
        <v-tabs
            v-model="activeTabInvoiceTheme"
            fixed-tabs
            grow
            style="background-color: transparent !important; border-radius: 12px"
            class="mb-1 w-100"
        >
            <v-tab rounded="0" ripple v-if="showInformationsTab" value="showInformationsTab"
                >Mes Informations</v-tab
            >
            <v-tab
                rounded="0"
                ripple
                v-if="showInvoiceThemeTab"
                value="showInvoiceThemeTab"
                data-cy="InvoiceThemeMenu-theme"
                >Thèmes</v-tab
            >
            <v-tab data-cy="invoice-settings" rounded="0" riple value="showAdvanceSettingsTab"
                >Paramètres avancés</v-tab
            >
        </v-tabs>
        <v-tabs-window v-model="activeTabInvoiceTheme" class="w-100">
            <v-tabs-window-item
                key="showInvoiceThemeTab"
                value="showInvoiceThemeTab"
                class="fill-height pt-1 ml-2 mr-2"
            >
                <v-row class="d-flex flex-row" style="position: sticky; top: 0">
                    <!-- <v-col class="d-flex justify-start align-center px-2" cols="8">
                        <v-radio-group v-model="isDefaultThemeSelected" row hide-details="auto">
                            <v-radio label="Par défaut" :value="true" @click="emitUseBobbeeInvoice()"></v-radio>
                            <v-radio label="Personnalisable" :value="false" @click="emitUseBobbeeInvoice()"></v-radio>
                        </v-radio-group>
                    </v-col> -->
                    <v-spacer />
                    <v-col cols="12" class="d-flex align-center justify-end px-2">
                        <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    rounded
                                    color="primary"
                                    elevation="0"
                                    class="ml-2"
                                        size="small"

                                    icon
                                    @click="emitPDFPreview()"
                                    v-bind="props"
                                >
                                    <v-icon>$fa-file-pdf</v-icon>
                                </v-btn>
                            </template>
                            <span>Prévisualiser le PDF</span>
                        </v-tooltip> -->
                        <VBtn @click="emitSaveTheme()" size="small" data-cy="InvoiceThemeMenu-save">
                            Enregistrer
                        </VBtn>
                    </v-col>
                    <v-col cols="6" class="d-flex pl-2 mb-2 justify-start">
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-checkbox
                                    v-model="invoiceThemeSettings.useAdvancedStyling"
                                    color="primary"
                                    label="Utiliser les options avancées de mise en page"
                                    density="compact"
                                    hide-details="auto"
                                    v-bind="props"
                                >
                                </v-checkbox>
                            </template>
                            <span
                                >La mise en page avancée vous permet de définir avec précision la
                                taille du contenu et des boîtes.</span
                            >
                        </v-tooltip>
                    </v-col>

                    <v-col cols="6">
                        <VSelectFilled
                            :items="previewDocumentTypes"
                            label="Type de document du preview"
                            density="compact"
                            hide-details
                            :model-value="selectedPreviewDocumentType"
                            @update:model-value="selectPreviewDocumentType($event)"
                            data-cy="InvoiceThemeMenu-typeDeDocumentPreview"
                        >
                        </VSelectFilled>
                    </v-col>
                </v-row>
                <!-- <v-row v-if="!isDefaultThemeSelected" no-gutters> -->
                <v-row no-gutters>
                    <v-col cols="12" class="pt-3">
                        <v-expansion-panels class="mb-3">
                            <v-expansion-panel @click="editing(null)">
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center">
                                        <b>Thèmes et arrière-plans</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <!-- Themes start-->
                                        <v-col cols="12" class="d-flex mb-2">
                                            <!-- <v-checkbox
                                                v-model="invoiceThemeSettings.page.useBackgroundImage"
                                                color="primary"
                                                label="Choisir un thème"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox> -->
                                            <label class="theme--light">Choisir un thème</label>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="d-flex mb-2 hide-scrollbar"
                                            style="overflow-y: auto"
                                        >
                                            <div
                                                style="cursor: pointer"
                                                @click="selectTheme({ name: 'Personal' })"
                                            >
                                                <v-card
                                                    flat
                                                    variant="outlined"
                                                    class="mx-1"
                                                    rounded="sm"
                                                    :color="
                                                        isThemeSelected({ name: 'Personal' })
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    "
                                                    :style="{
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth: isThemeSelected({
                                                            name: 'Personal',
                                                        })
                                                            ? '2px'
                                                            : '',
                                                    }"
                                                >
                                                    <!-- <v-img
                                                        :src="theme.thumbnailUri"
                                                        :alt="theme.name"
                                                        style="max-height: 149px"
                                                    >
                                                    </v-img> -->

                                                    <!-- {{ img.frontSrc }} -->
                                                </v-card>
                                                <div
                                                    class="mr-1"
                                                    style="
                                                        font-size: small;
                                                        width: 100%;
                                                        text-align: center;
                                                        text-overflow: ellipsis;
                                                    "
                                                >
                                                    Votre thème personnalisé
                                                </div>
                                            </div>
                                            <div
                                                v-for="theme in getAvailableThemes"
                                                :key="theme.name"
                                                style="cursor: pointer"
                                                @click="selectTheme(theme)"
                                            >
                                                <v-card
                                                    v-if="theme.name === 'Par défaut'"
                                                    flat
                                                    variant="outlined"
                                                    rounded="sm"
                                                    class="mx-1"
                                                    :color="
                                                        isThemeSelected(theme)
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    "
                                                    :style="{
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth: isThemeSelected(theme)
                                                            ? '2px'
                                                            : '',
                                                    }"
                                                >
                                                    <v-img
                                                        :src="theme.thumbnailUri"
                                                        :alt="theme.name"
                                                        style="max-height: 149px"
                                                    >
                                                    </v-img>

                                                    <!-- {{ img.frontSrc }} -->
                                                </v-card>
                                                <v-card
                                                    v-else
                                                    flat
                                                    variant="outlined"
                                                    rounded="sm"
                                                    class="mx-1"
                                                    :color="
                                                        isThemeSelected(theme)
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    "
                                                    :style="{
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth: isThemeSelected(theme)
                                                            ? '2px'
                                                            : '',
                                                    }"
                                                >
                                                    <v-img
                                                        :src="theme.thumbnailUri"
                                                        :alt="theme.name"
                                                        style="max-height: 149px"
                                                    >
                                                    </v-img>

                                                    <!-- {{ img.frontSrc }} -->
                                                </v-card>
                                                <div
                                                    class="mr-1"
                                                    style="
                                                        font-size: x-small;
                                                        width: 100%;
                                                        text-align: center;
                                                        text-overflow: ellipsis;
                                                    "
                                                >
                                                    {{ theme.name }}
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <!-- Themes end-->
                                    <v-row no-gutters>
                                        <!-- Backgrounds start-->
                                        <v-col cols="12" class="d-flex mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.page.useBackgroundImage
                                                "
                                                color="primary"
                                                label="Choisir un fond par défaut ou ajouter un fond personnalisé"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="d-flex mb-2 hide-scrollbar"
                                            style="overflow-y: auto"
                                        >
                                            <div>
                                                <v-card
                                                    flat
                                                    variant="outlined"
                                                    rounded="sm"
                                                    class="mx-1 flex align-center justify-center"
                                                    :color="
                                                        isPersonalizedBackgroundSelected
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    "
                                                    :style="{
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth:
                                                            isPersonalizedBackgroundSelected
                                                                ? '2px'
                                                                : '',
                                                    }"
                                                >
                                                    <v-img
                                                        v-if="personalizedBgImage"
                                                        :src="personalizedBgImage"
                                                        alt="Fond personnalisé"
                                                        style="max-height: 149px; cursor: pointer"
                                                        @click="selectPersonalizedBackground()"
                                                    >
                                                    </v-img>
                                                    <v-row
                                                        v-else
                                                        class="no-gutters d-flex align-center justify-center"
                                                        style="height: 149px"
                                                    >
                                                        <v-btn-icon
                                                            @click="openInvoiceBgUploadDialog"
                                                            :disabled="
                                                                !invoiceThemeSettings.page
                                                                    .useBackgroundImage
                                                            "
                                                            icon="$oss-upload"
                                                        >
                                                        </v-btn-icon>
                                                    </v-row>
                                                </v-card>
                                                <div
                                                    class="mr-1"
                                                    style="
                                                        font-size: x-small;
                                                        width: 100%;
                                                        text-align: center;
                                                        text-overflow: ellipsis;
                                                    "
                                                >
                                                    <span>Personnalisé</span>
                                                    <v-btn-icon
                                                        icon="$oss-upload"
                                                        @click="openInvoiceBgUploadDialog"
                                                        :disabled="
                                                            !invoiceThemeSettings.page
                                                                .useBackgroundImage
                                                        "
                                                        style="font-size: x-small; padding: 0"
                                                    >
                                                    </v-btn-icon>
                                                </div>
                                            </div>
                                            <div
                                                v-for="img in defaultBackgroundsDataList"
                                                :key="img.name"
                                                style="cursor: pointer"
                                                @click="selectDefaultBackground(img.fileKey)"
                                            >
                                                <v-card
                                                    flat
                                                    variant="outlined"
                                                    rounded="sm"
                                                    class="mx-1"
                                                    :color="
                                                        isDefaultBackgroundSelected(img.fileKey)
                                                            ? 'primary'
                                                            : 'rgba(0, 0, 0, 0.12)'
                                                    "
                                                    :style="{
                                                        height: '149px',
                                                        width: '105px',
                                                        borderWidth: isDefaultBackgroundSelected(
                                                            img.fileKey,
                                                        )
                                                            ? '2px'
                                                            : '',
                                                    }"
                                                >
                                                    <v-img
                                                        :src="img.signedUrl"
                                                        :alt="img.name"
                                                        style="max-height: 149px"
                                                    >
                                                    </v-img>

                                                    <!-- {{ img.frontSrc }} -->
                                                </v-card>
                                                <div
                                                    class="mr-1"
                                                    style="
                                                        font-size: x-small;
                                                        width: 100%;
                                                        text-align: center;
                                                        text-overflow: ellipsis;
                                                    "
                                                >
                                                    {{ img.name }}
                                                </div>
                                            </div>
                                        </v-col>

                                        <!-- <v-col cols="6" class="d-flex flex-column pl-2 mb-2">
                                            <div class="d-flex flex-row">
                                                <v-btn outlined
                                                    color="primary"
                                                    @click="openInvoiceBgUploadDialog"
                                                    :disabled="!invoiceThemeSettings.page.useBackgroundImage"
                                                >
                                                    <span class="mx-2">Changer</span>
                                                    <v-icon  size="small">$fa-upload</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-col>   -->
                                        <v-col cols="12" />
                                        <!-- <v-col cols="6" class="d-flex pl-2 mb-2">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.page.useBackgroundImage"
                                                color="primary"
                                                label="Utiliser une image d'arrière-plan"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col> -->
                                        <v-col cols="6" class="d-flex pl-2 mb-2">
                                            <VSelectFilled
                                                :items="backgroundSizeItems"
                                                label="Taille de l'arrière-plan"
                                                hide-details
                                                :disabled="
                                                    !invoiceThemeSettings.page.useBackgroundImage
                                                "
                                                v-model="invoiceThemeSettings.page.backgroundSize"
                                                density="compact"
                                            >
                                            </VSelectFilled>
                                        </v-col>
                                        <v-col cols="6" class="d-flex pl-2 mb-2">
                                            <VSelectFilled
                                                :items="backgroundPositionItems"
                                                label="Position de l'arrière-plan"
                                                hide-details
                                                :disabled="
                                                    !invoiceThemeSettings.page.useBackgroundImage
                                                "
                                                v-model="
                                                    invoiceThemeSettings.page.backgroundPosition
                                                "
                                                density="compact"
                                            >
                                            </VSelectFilled>
                                        </v-col>
                                        <v-col cols="6" class="d-flex pl-2 mb-2">
                                            <VSelectFilled
                                                :items="backgroundRepeatItems"
                                                label="Répétition de l'arrière-plan"
                                                hide-details
                                                :disabled="
                                                    !invoiceThemeSettings.page.useBackgroundImage
                                                "
                                                v-model="invoiceThemeSettings.page.backgroundRepeat"
                                                density="compact"
                                            >
                                            </VSelectFilled>
                                        </v-col>
                                        <v-col cols="6" class="d-flex pl-2 mb-2">
                                            <CustomNumberField
                                                v-model="
                                                    invoiceThemeSettings.page.backgroundOpacity
                                                "
                                                label="Opacité"
                                                :step="1"
                                                :min="0"
                                                :max="100"
                                                :disabled="
                                                    !invoiceThemeSettings.page.useBackgroundImage
                                                "
                                                hide-details
                                                data-cy="InvoiceThmeMenu-opacite"
                                            >
                                                <template #pre-append>
                                                    <div
                                                        style="
                                                            font-size: small;
                                                            height: fit-content;
                                                            margin: auto;
                                                        "
                                                    >
                                                        %
                                                    </div>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                    </v-row>
                                    <!-- Backgrounds start-->
                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel
                                @click="editing(null)"
                                data-cy="InvoiceThemeMenu-general"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center">
                                        <b>Général</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <v-col cols="6" class="d-flex flex-column pl-2 mt-2 mb-2">
                                            <!-- <span>Marges horizontales</span>
                                            <v-slider
                                                v-model="horizontalMargin"
                                                :max="4"
                                                step="1"
                                                ticks="always"
                                                tick-size="1"
                                                color="primary"
                                                hide-details
                                            ></v-slider> -->
                                            <CustomNumberField
                                                v-model="horizontalMargin"
                                                label="Marges horizontales"
                                                class="mt-3"
                                                :step="0.1"
                                                :min="0"
                                                hide-details
                                                data-cy="InvoiceThemeMenu-margesHorizontales"
                                            >
                                                <template #pre-append>
                                                    <span>mm</span>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                        <v-col cols="6" class="d-flex flex-column pl-2 mt-2 mb-2">
                                            <!-- <span>Marges verticales</span>
                                            <v-slider
                                                v-model="verticalMargin"
                                                :max="4"
                                                step="1"
                                                ticks="always"
                                                tick-size="1"
                                                color="primary"
                                                hide-details
                                            ></v-slider> -->
                                            <CustomNumberField
                                                v-model="verticalMargin"
                                                label="Marges verticales"
                                                class="mt-3"
                                                :step="0.1"
                                                :min="0"
                                                hide-details
                                                data-cy="InvoiceThemeMenu-margesVerticales"
                                            >
                                                <template #pre-append>
                                                    <span>mm</span>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                        <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <VSelectFilled
                                                :items="fonts"
                                                label="Police"
                                                density="compact"
                                                hide-details
                                                :model-value="selectedFontFamily"
                                                @update:model-value="
                                                    (val) => handleFontSelectChange(val)
                                                "
                                                data-cy="InvoiceThemeMenu-police"
                                            >
                                                <template #item="{ item, props }">
                                                    <v-list-item
                                                        v-bind="props"
                                                        :title="null"
                                                        style="width: 100%"
                                                    >
                                                        <v-list-item-title
                                                            v-bind="props"
                                                            @mouseover="onFontMouseOver(item.raw)"
                                                            @mouseleave="onFontMouseLeave(item.raw)"
                                                            v-if="item.raw !== 'Par défaut'"
                                                            :style="{
                                                                fontFamily: item.raw,
                                                                width: '100%',
                                                                cursor: 'pointer',
                                                            }"
                                                        >
                                                            {{ item.raw }}
                                                        </v-list-item-title>
                                                        <v-list-item-title v-else>{{
                                                            item.raw
                                                        }}</v-list-item-title>
                                                    </v-list-item>
                                                </template>
                                                <template #selection="{ item, index }">
                                                    <div
                                                        v-if="item.raw !== 'Par défaut'"
                                                        :style="{ fontFamily: item.raw }"
                                                    >
                                                        {{ item.raw }}
                                                    </div>
                                                    <div v-else>{{ item.raw }}</div>
                                                </template>
                                            </VSelectFilled>
                                        </v-col>
                                        <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <!-- <VTextFieldFilled
                                                v-model="selectedFontSize"
                                                label="Taille de police"
                                                density="compact"
                                                hide-details
                                                type="number"
                                                min="6"
                                                max="24"
                                                step="1"
                                            >
                                            </VTextFieldFilled> -->
                                            <CustomNumberField
                                                v-model="selectedFontSize"
                                                label="Taille de police"
                                                :step="1"
                                                :min="1"
                                                :max="maxFontSize"
                                                hide-details
                                                data-cy="InvoiceThemeMenu-taillePolice"
                                            >
                                                <!-- <template #append-outer>
                                                    <span>mm</span>
                                                </template> -->
                                            </CustomNumberField>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-text>
                                <oss-dialog
                                    v-model="invoiceBgUploadDialog"
                                    v-if="invoiceBgUploadDialog"
                                    title="Importer un arrière plan"
                                    :actions="actions"
                                    max-width="900"
                                >
                                    <UploadDocuments
                                        key="background"
                                        :companyId="companyId"
                                        :documentType="'BOOKLET_TEMPLATE'"
                                        :multiple="false"
                                        :freeTag="false"
                                        :actions="actions"
                                        :showActionsBtn="true"
                                        :inExtensions="['png', 'jpg', 'webp', 'jpeg']"
                                        @file="updateInvoiceBackground($event)"
                                        @file-uploaded="invoiceBgUploadDialog = false"
                                    />
                                </oss-dialog>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('invoiceHeader-block')"
                                data-cy="InvoiceThemeMenu-enTeteDeLaPage"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center">
                                        <b>En-tête de la page</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <!-- <v-col cols="4" class="d-flex mt-2 mb-2">
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="invoiceThemeSettings.emitter.style.backgroundColor"
                                                                v-bind="props"
                                                                label="Emetteur"
                                                                density="compact"
                                                                readonly
                                                                hide-details
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div class="d-flex align-self-center" :style="colorIconStyle('header')"></div>
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="invoiceThemeSettings.emitter.style.backgroundColor"
                                                    show-swatches
                                                    hide-sliders
                                                    hide-inputs
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="invoiceThemeSettings.receiver.style.backgroundColor"
                                                                v-bind="props"
                                                                label="Destinataire"
                                                                density="compact"
                                                                readonly
                                                                hide-details
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div class="d-flex align-self-center" :style="colorIconStyle('rows')"></div>
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="invoiceThemeSettings.receiver.style.backgroundColor"
                                                    show-swatches
                                                    hide-sliders
                                                    hide-inputs
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col> -->
                                        <!-- <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                                    <v-menu offset-y>
                                                        <template v-slot:activator="{ props }">
                                                            <v-row no-gutters>
                                                                <v-col cols="12">
                                                                    <VTextFieldFilled
                                                                        v-model="invoiceThemeSettings.style.backgroundColor"
                                                                        v-bind="props"
                                                                        label="Fond"
                                                                        density="compact"
                                                                        readonly
                                                                        hide-details
                                                                    >
                                                                        <template v-slot:prepend-inner>
                                                                            <div class="d-flex align-self-center" :style="colorIconStyle('rows')"></div>
                                                                        </template>
                                                                    </VTextFieldFilled>
                                                                </v-col>
                                                            </v-row>
                                                        </template>
                                                        <v-color-picker
                                                            v-model="invoiceThemeSettings.style.backgroundColor"
                                                            show-swatches
                                                            hide-sliders
                                                            hide-inputs
                                                            hide-mode-switch
                                                            :swatches="swatches"
                                                        >
                                                        </v-color-picker>
                                                    </v-menu>
                                                </v-col> -->
                                        <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                "
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                                data-cy="InvoiceThemeMenu-cacherLeBloc"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <!-- <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.page.showPageHeader"
                                                color="primary"
                                                label="Afficher l'en-tête de page"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col> -->
                                        <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.style.displayHeaderDivider
                                                "
                                                label="Afficher le trait de séparation"
                                                color="primary"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                "
                                                data-cy="InvoiceThemeMenu-traitSeparation"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                            <v-checkbox
                                                v-model="showLogo"
                                                label="Logo"
                                                color="primary"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                "
                                                data-cy="InvoiceThemeMenu-logo"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="8" class="d-flex flex-column pl-2 mt-2 mb-2">
                                            <v-slider
                                                v-model="logoSizeMultiplier"
                                                :show-ticks="false"
                                                color="primary"
                                                density="compact"
                                                max="500"
                                                min="0"
                                                step="10"
                                                label="Taille du logo"
                                                hide-details
                                                :disabled="
                                                    invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                "
                                            />
                                        </v-col>
                                        <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.headerContentBox
                                                        .invoiceTypeBox.showInvoiceType
                                                "
                                                color="primary"
                                                label="Afficher le type de facture"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.headerContentBox
                                                        .invoiceTypeBox.useInvoiceNumber
                                                "
                                                label="Utiliser le numéro de la facture à la place"
                                                color="primary"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                "
                                                data-cy="InvoiceThemeMenu-numeroFacture"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <v-checkbox
                                                v-model="logoOnRightSide"
                                                label="Logo à droite"
                                                color="primary"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.headerContentBox.style
                                                        .hidden
                                                "
                                                data-cy="InvoiceThemeMenu-logoDroite"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.headerContentBox.style"
                                        :perRow="2"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        editedElementClass="invoiceHeader-block"
                                        title="Options avancéees d'édition de l'entête"
                                        @editing="editing"
                                        :unusedOptions="hiddenUnusedOption"
                                        :disabled="
                                            invoiceThemeSettings.headerContentBox.style.hidden
                                        "
                                    >
                                    </AdvancedBoxEditor>
                                    <AdvancedBoxEditor
                                        v-model="
                                            invoiceThemeSettings.headerContentBox.iconBox.style
                                        "
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="invoiceHeaderLogo-block"
                                        title="Options avancéees de format du logo"
                                        @editing="editing"
                                        :disabled="
                                            invoiceThemeSettings.headerContentBox.style.hidden
                                        "
                                        :disabledHidden="
                                            invoiceThemeSettings.headerContentBox.style.hidden
                                        "
                                    >
                                    </AdvancedBoxEditor>
                                    <AdvancedBoxEditor
                                        v-model="
                                            invoiceThemeSettings.headerContentBox.invoiceTypeBox
                                                .style
                                        "
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="invoiceHeaderType-block"
                                        title="Options avancéees de format du type de document"
                                        @editing="editing"
                                        :disabled="
                                            invoiceThemeSettings.headerContentBox.style.hidden
                                        "
                                        :disabledHidden="
                                            invoiceThemeSettings.headerContentBox.style.hidden
                                        "
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('emitter-block')"
                                data-cy="InvoiceThemeMenu-emmetteur"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Emetteur</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters class="d-flex pl-2">
                                        <v-col cols="6" class="d-flex">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.style.hidden"
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                                data-cy="InvoiceThemeMenu-emetteurCacherBloc"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.logo"
                                                color="primary"
                                                label="Logo"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.emitter.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <template v-if="invoiceThemeSettings.emitter.logo">
                                            <v-col
                                                cols="8"
                                                class="d-flex flex-column pl-2 mt-2 mb-2"
                                            >
                                                <v-slider
                                                    v-model="logoSizeMultiplier"
                                                    :show-ticks="false"
                                                    max="500"
                                                    min="0"
                                                    step="10"
                                                    label="Taille du logo"
                                                    hide-details
                                                    :disabled="!invoiceThemeSettings.emitter.logo"
                                                />
                                            </v-col>
                                            <v-col cols="4" />
                                        </template>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.name"
                                                color="primary"
                                                label="Nom émetteur"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.emitter.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.address"
                                                color="primary"
                                                label="Adresse émetteur"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.emitter.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.siret"
                                                color="primary"
                                                label="Siret émetteur"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.emitter.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.tva"
                                                color="primary"
                                                label="TVA"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.emitter.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <!-- <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.email"
                                                color="primary"
                                                label="Adresse email"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="invoiceThemeSettings.emitter.style.hidden"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.phone"
                                                color="primary"
                                                label="Téléphone"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="invoiceThemeSettings.emitter.style.hidden"
                                            >
                                            </v-checkbox>
                                        </v-col> -->
                                    </v-row>
                                    <v-row no-gutters class="d-flex pl-2">
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.style.border"
                                                color="primary"
                                                label="Bordures"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.emitter.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <!-- <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.emitter.email"
                                                color="primary"
                                                label="Email émetteur"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col> -->
                                        <v-col cols="4" class="pl-2 mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.emitter
                                                                        .style.borderColor
                                                                "
                                                                v-bind="props"
                                                                label="Bordures"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    !invoiceThemeSettings.emitter
                                                                        .style.border ||
                                                                    invoiceThemeSettings.emitter
                                                                        .style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'emitter.style.borderColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="emitterBorderColor"
                                                    show-swatches
                                                    hide-mode-switch
                                                    mode="hexa"
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.emitter.style.hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="4" class="pl-2 mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.emitter
                                                                        .style.backgroundColor
                                                                "
                                                                v-bind="props"
                                                                label="Fond"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    !invoiceThemeSettings.emitter
                                                                        .style.border ||
                                                                    invoiceThemeSettings.emitter
                                                                        .style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'emitter.style.backgroundColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="emitterBgColor"
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.emitter.style.hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pl-2 my-1">
                                        <v-col cols="6">
                                            Position du texte<br />
                                            <v-btn-toggle
                                                mandatory="force"
                                                divided
                                                variant="outlined"
                                                v-model="
                                                    invoiceThemeSettings.emitter.style.textPosition
                                                "
                                                :disabled="
                                                    invoiceThemeSettings.emitter.style.hidden
                                                "
                                                density="comfortable"
                                            >
                                                <v-btn-icon
                                                    icon="$fa-align-left"
                                                    value="left"
                                                    size="small"
                                                    variant="outlined"
                                                >
                                                </v-btn-icon>
                                                <v-btn-icon
                                                    icon="$fa-align-center"
                                                    value="center"
                                                    data-cy="InvoiceThemeMenu-center"
                                                    size="small"
                                                    variant="outlined"
                                                >
                                                </v-btn-icon>
                                            </v-btn-toggle>
                                        </v-col>
                                        <v-col cols="6" class="d-flex align-center">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.position.emitter
                                                        .sameLevelAsReceiver
                                                "
                                                color="primary"
                                                label="Aligné avec le destinataire"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.emitter.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <!-- <v-row no-gutters class="pl-2 my-1">
                                        <v-col cols="12" class="my-2">
                                            <v-divider style="width: 100%;"></v-divider>
                                        </v-col>
                                        <v-col cols="6" class="px-2 py-2">
                                            <CustomNumberField
                                                v-model="invoiceThemeSettings.emitter.style.boxHeight"
                                                label="Hauteur de la boite"
                                                :step="0.1"
                                                :min="0"
                                                hide-details>
                                                <template #pre-append>
                                                    <span class="text-small">mm</span>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                        <v-col cols="6" class="pr-2 py-2">
                                            <CustomNumberField
                                                v-model="invoiceThemeSettings.emitter.style.boxWidth"
                                                label="Largeur de la boite"
                                                :step="0.1"
                                                :min="0"
                                                hide-details>
                                                <template #pre-append>
                                                    <span class="text-small">mm</span>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                        <v-col cols="6" class="px-2 py-2">
                                            <CustomNumberField
                                                v-model="invoiceThemeSettings.emitter.style.padding"
                                                label="Marges intérieures"
                                                :step="0.1"
                                                :min="0"
                                                hide-details>
                                                <template #pre-append>
                                                    <span class="text-small">mm</span>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                        <v-col cols="6" class="px-2 py-2">
                                            <CustomNumberField
                                                v-model="invoiceThemeSettings.emitter.style.leftMargin"
                                                label="Marge gauche"
                                                :step="0.1"
                                                :min="0"
                                                hide-details>
                                                <template #pre-append>
                                                    <span class="text-small">mm</span>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                        <v-col cols="6" class="px-2 py-2">
                                            <CustomNumberField
                                                v-model="invoiceThemeSettings.emitter.style.rightMargin"
                                                label="Marge droite"
                                                :step="0.1"
                                                :min="0"
                                                hide-details>
                                                <template #pre-append>
                                                    <span class="text-small">mm</span>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                        <v-col cols="6" class="px-2 py-2">
                                            <CustomNumberField
                                                v-model="invoiceThemeSettings.emitter.style.topMargin"
                                                label="Marge supérieure"
                                                :step="0.1"
                                                :min="0"
                                                hide-details>
                                                <template #pre-append>
                                                    <span class="text-small">mm</span>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                        <v-col cols="6" class="px-2 py-2">
                                            <CustomNumberField
                                                v-model="invoiceThemeSettings.emitter.style.leftMargin"
                                                label="Marge inférieure"
                                                :step="0.1"
                                                :min="0"
                                                hide-details>
                                                <template #pre-append>
                                                    <span class="text-small">mm</span>
                                                </template>
                                            </CustomNumberField>
                                        </v-col>
                                    </v-row> -->
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.emitter.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="emitter-block"
                                        @editing="editing"
                                        :disabled="invoiceThemeSettings.emitter.style.hidden"
                                        :unusedOptions="[
                                            'hidden',
                                            'border',
                                            'borderColor',
                                            'backgroundColor',
                                        ]"
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('receiver-block')"
                                data-cy="InvoiceThemeMenu-destinataire"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Destinataire</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters class="d-flex pl-2">
                                        <v-col cols="12" class="d-flex">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.receiver.style.hidden"
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.receiver.name"
                                                color="primary"
                                                label="Nom destinataire"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.receiver.style.hidden
                                                "
                                                data-cy="InvoiceThemeMenu-nomDestinataire"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.receiver.address"
                                                color="primary"
                                                label="Adresse destinataire"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.receiver.style.hidden
                                                "
                                                data-cy="InvoiceThemeMenu-adresseDestinataire"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.receiver.siret"
                                                color="primary"
                                                label="Siret destinataire"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.receiver.style.hidden
                                                "
                                                data-cy="InvoiceThemeMenu-siretDestinataire"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.receiver.tva"
                                                color="primary"
                                                label="TVA"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.receiver.style.hidden
                                                "
                                                data-cy="InvoiceThemeMenu-TVA"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <!-- Unused options -->
                                        <!-- <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.receiver.email"
                                                color="primary"
                                                label="Adresse email"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.receiver.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.receiver.phone"
                                                color="primary"
                                                label="Téléphone"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.receiver.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col> -->
                                    </v-row>
                                    <v-row no-gutters class="d-flex pl-2">
                                        <v-col cols="4" class="mt-2 mb-2">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.receiver.style.border"
                                                color="primary"
                                                label="Bordures"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.receiver.style.hidden
                                                "
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pl-2 mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.receiver
                                                                        .style.borderColor
                                                                "
                                                                v-bind="props"
                                                                label="Bordures"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    !invoiceThemeSettings.receiver
                                                                        .style.border ||
                                                                    invoiceThemeSettings.receiver
                                                                        .style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'receiver.style.borderColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="receiverBorderColor"
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.receiver.style.hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="4" class="pl-2 mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.receiver
                                                                        .style.backgroundColor
                                                                "
                                                                v-bind="props"
                                                                label="Fond"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    !invoiceThemeSettings.receiver
                                                                        .style.border ||
                                                                    invoiceThemeSettings.receiver
                                                                        .style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'receiver.style.backgroundColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="receiverBgColor"
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.receiver.style.hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <!-- <v-col cols="4">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.receiver.email"
                                                color="primary"
                                                label="Email destinataire"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col> -->
                                    </v-row>
                                    <v-row no-gutters class="d-flex pl-2 my-1">
                                        <v-col cols="6">
                                            Position du texte<br />
                                            <v-btn-toggle
                                                mandatory="force"
                                                divided
                                                variant="outlined"
                                                density="comfortable"
                                                v-model="
                                                    invoiceThemeSettings.receiver.style.textPosition
                                                "
                                            >
                                                <v-btn-icon
                                                    icon="$fa-align-left"
                                                    value="left"
                                                    size="small"
                                                    variant="outlined"
                                                >
                                                </v-btn-icon>
                                                <v-btn-icon
                                                    data-cy="InvoiceThemeMenu-destinataireCenter"
                                                    value="center"
                                                    icon="$fa-align-center"
                                                    size="small"
                                                    variant="outlined"
                                                >
                                                </v-btn-icon>
                                                <v-btn-icon
                                                    icon="$fa-align-right"
                                                    value="right"
                                                    size="small"
                                                    variant="outlined"
                                                >
                                                </v-btn-icon>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.receiver.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="receiver-block"
                                        @editing="editing"
                                        :unusedOptions="[
                                            'hidden',
                                            'border',
                                            'borderColor',
                                            'backgroundColor',
                                        ]"
                                        :disabled="invoiceThemeSettings.receiver.style.hidden"
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('invoiceTitle-block')"
                                data-cy="InvoiceThemeMenu-titreInfosFacture"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Titre et infos de la facture</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <!-- TODO add customization options-->
                                        <v-col cols="12" class="d-flex">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.titleBox.style.hidden"
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.titleBox.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="invoiceTitle-block"
                                        title="Options avancéees d'édition"
                                        @editing="editing"
                                        :divider="false"
                                        :unusedOptions="['hidden']"
                                        :disabled="invoiceThemeSettings.titleBox.style.hidden"
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('mainTable-block')"
                                data-cy="InvoiceThemeMenu-tableauCentral"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Tableau central</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="d-flex mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.mainTableBox.style.hidden
                                                "
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4" class="d-flex mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.tables
                                                                        .header.backgroundColor
                                                                "
                                                                v-bind="props"
                                                                label="En-tête"
                                                                density="compact"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                "
                                                                data-cy="InvoiceThemeMenu-enTeteColor"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'tables.header.backgroundColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="tableHeaderBgColor"
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    "
                                                    data-cy="InvoiceThemeMenu-color"
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.tables.rows
                                                                        .backgroundColor
                                                                "
                                                                v-bind="props"
                                                                label="Lignes"
                                                                density="compact"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                "
                                                                data-cy="InvoiceThemeMenu-lignes"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'tables.rows.backgroundColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="tableRowBgColor"
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="4" class="d-flex pl-3">
                                            <v-checkbox
                                                v-model="invoiceThemeSettings.tables.rows.border"
                                                color="primary"
                                                label="Bordures"
                                                density="compact"
                                                :disabled="
                                                    invoiceThemeSettings.mainTableBox.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="4" class="d-flex pt-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <VTextFieldFilled
                                                        v-model="
                                                            invoiceThemeSettings.tables.rows
                                                                .borderColor
                                                        "
                                                        v-bind="props"
                                                        label="Bordures"
                                                        readonly
                                                        hide-details
                                                        :disabled="
                                                            invoiceThemeSettings.mainTableBox.style
                                                                .hidden
                                                        "
                                                        density="compact"
                                                    >
                                                        <template v-slot:prepend-inner>
                                                            <div
                                                                class="d-flex align-self-center"
                                                                :style="
                                                                    colorIconStyle(
                                                                        'tables.rows.borderColor',
                                                                    )
                                                                "
                                                            />
                                                        </template>
                                                    </VTextFieldFilled>
                                                </template>
                                                <v-color-picker
                                                    v-model="tableRowBorderColor"
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <!-- Add options here -->
                                        <v-col cols="4" class="d-flex pt-2 pl-3">
                                            <VSelectFilled
                                                :items="tableRowsTypes"
                                                item-title="text"
                                                label="Mode de ligne du tableau"
                                                density="compact"
                                                hide-details
                                                v-model="
                                                    invoiceThemeSettings.mainTableBox.rows.mode
                                                "
                                                :disabled="
                                                    invoiceThemeSettings.mainTableBox.style.hidden
                                                "
                                                data-cy="InvoiceThemeMenu-modeDeLigneDuTableau"
                                            >
                                            </VSelectFilled>
                                        </v-col>
                                        <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings
                                                                        .mainTableBox.rows
                                                                        .secondaryBackgroundColor
                                                                "
                                                                v-bind="props"
                                                                label="Lignes (secondaire)"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings
                                                                        .mainTableBox.rows.mode !==
                                                                        'alternating' ||
                                                                    invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'mainTableBox.rows.secondaryBackgroundColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="
                                                        invoiceThemeSettings.mainTableBox.rows
                                                            .secondaryBackgroundColor
                                                    "
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters class="py-3">
                                        <v-col cols="12">
                                            <span class="text-muted">Colonnes</span>
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <draggable
                                                        :list="tableColumns"
                                                        @change="onDraggableMove"
                                                        ghost-class="ghost"
                                                        :disabled="
                                                            invoiceThemeSettings.mainTableBox.style
                                                                .hidden
                                                        "
                                                        itemKey=""
                                                        class="v-row v-row--no-gutters"
                                                    >
                                                        <template #item="{ element: column }">
                                                            <v-col
                                                                :key="column.value"
                                                                cols="12"
                                                                class="py-2"
                                                            >
                                                                <v-row
                                                                    no-gutters
                                                                    class="d-flex align-center justify-center"
                                                                >
                                                                    <div
                                                                        class="d-inline-block pr-1"
                                                                        style="cursor: move"
                                                                    >
                                                                        <v-icon
                                                                            icon="$fa-grip-vertical"
                                                                            size="x-small"
                                                                            color="secondary"
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        class="d-inline-block pl-1"
                                                                    >
                                                                        <v-checkbox
                                                                            v-model="column.checked"
                                                                            color="primary"
                                                                            class="pa-0"
                                                                            density="compact"
                                                                            hide-details="auto"
                                                                            :disabled="
                                                                                !column.optional ||
                                                                                invoiceThemeSettings
                                                                                    .mainTableBox
                                                                                    .style.hidden
                                                                            "
                                                                            @update:model-value="
                                                                                updateTableHeaderInTheme
                                                                            "
                                                                            :data-cy="
                                                                                'InvoiceThemeMenu-ajouterSupprimerLigne-' +
                                                                                column.value
                                                                            "
                                                                        >
                                                                        </v-checkbox>
                                                                    </div>
                                                                    <v-col class="px-2">
                                                                        <VTextFieldFilled
                                                                            v-model="column.text"
                                                                            :label="column.column"
                                                                            hide-details
                                                                            :disabled="
                                                                                invoiceThemeSettings
                                                                                    .mainTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            "
                                                                            @update:model-value="
                                                                                updateTableHeaderInTheme
                                                                            "
                                                                            density="compact"
                                                                        >
                                                                        </VTextFieldFilled>
                                                                    </v-col>
                                                                    <!-- <v-col class="px-2"> -->
                                                                    <div
                                                                        class="d-inline-block px-1"
                                                                    >
                                                                        <v-checkbox
                                                                            v-model="
                                                                                column.boldText
                                                                            "
                                                                            label="Gras"
                                                                            density="compact"
                                                                            hide-details
                                                                            color="primary"
                                                                            :disabled="
                                                                                invoiceThemeSettings
                                                                                    .mainTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            "
                                                                            @update:model-value="
                                                                                updateTableHeaderInTheme
                                                                            "
                                                                            data-cy="InvoiceThemeMenu-gras"
                                                                        >
                                                                        </v-checkbox>
                                                                    </div>
                                                                    <!-- </v-col> -->
                                                                    <!-- <v-col class="px-2"> -->
                                                                    <div
                                                                        class="d-inline-block px-1"
                                                                    >
                                                                        <v-btn-toggle
                                                                            mandatory="force"
                                                                            v-model="column.align"
                                                                            divided
                                                                            variant="outlined"
                                                                            @update:model-value="
                                                                                updateTableHeaderInTheme
                                                                            "
                                                                        >
                                                                            <v-btn-icon
                                                                                icon="$fa-align-left"
                                                                                value="left"
                                                                                size="x-small"
                                                                                variant="outlined"
                                                                            >
                                                                            </v-btn-icon>
                                                                            <v-btn-icon
                                                                                icon="$fa-align-center"
                                                                                value="center"
                                                                                size="x-small"
                                                                                variant="outlined"
                                                                            >
                                                                            </v-btn-icon>
                                                                            <v-btn-icon
                                                                                icon="$fa-align-right"
                                                                                value="right"
                                                                                data-cy="InvoiceThemeMenu-right"
                                                                                size="x-small"
                                                                                variant="outlined"
                                                                            >
                                                                            </v-btn-icon>
                                                                        </v-btn-toggle>
                                                                    </div>
                                                                    <!-- </v-col> -->
                                                                    <v-col>
                                                                        <!-- <VTextFieldFilled
                                                                            v-model="column.width"
                                                                            label="Largeur %"
                                                                            density="compact"
                                                                            hide-details
                                                                            @update:model-value="updateTableHeaderInTheme"
                                                                        >
                                                                        </VTextFieldFilled> -->
                                                                        <CustomNumberField
                                                                            v-model="column.width"
                                                                            label="Largeur"
                                                                            :step="1"
                                                                            :min="1"
                                                                            :max="
                                                                                mainTableRemainingCellWidthPercent
                                                                            "
                                                                            placeholder="Auto"
                                                                            class="w-100"
                                                                            @change="
                                                                                (e) => {
                                                                                    mainTableCellInEditionWidth =
                                                                                        e;
                                                                                    updateTableHeaderInTheme();
                                                                                }
                                                                            "
                                                                            hide-details
                                                                            :disabled="
                                                                                invoiceThemeSettings
                                                                                    .mainTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            "
                                                                        >
                                                                            <template #pre-append>
                                                                                <div
                                                                                    style="
                                                                                        font-size: small;
                                                                                        height: fit-content;
                                                                                        margin: auto;
                                                                                    "
                                                                                >
                                                                                    %
                                                                                </div>
                                                                            </template>
                                                                            <!-- <template #append-outer>
                                                                                <span class="text-small">mm</span>
                                                                            </template> -->
                                                                        </CustomNumberField>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </template>
                                                    </draggable>
                                                </v-col>
                                                <!-- <v-col cols="12" no-gutters class="d-flex align-center justify-start">
                                                    <v-btn
                                                        color="primary"
                                                        outlined
                                                        rounded
                                                        @click="addEmptyColumn"
                                                    >
                                                        <v-icon  size="small">$fa-plus</v-icon>
                                                        <span class="pl-2">Colonne</span>
                                                    </v-btn>
                                                </v-col> -->
                                                <v-col cols="12" class="d-flex pa-2">
                                                    <v-checkbox
                                                        v-model="
                                                            invoiceThemeSettings.mainTableBox.rows
                                                                .hideProductionDescription
                                                        "
                                                        label="Cacher la description du produit"
                                                        color="primary"
                                                        class="pa-0"
                                                        density="compact"
                                                        hide-details="auto"
                                                        :disabled="
                                                            invoiceThemeSettings.mainTableBox.style
                                                                .hidden
                                                        "
                                                        data-cy="InvoiceThemeMenu-cacherLaDescriptionDuProduit"
                                                    >
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="py-3">
                                        <v-col cols="12"
                                            ><span class="text-muted">Lignes</span></v-col
                                        >
                                        <v-col cols="6" class="d-flex px-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.mainTableBox.rows
                                                        .showDiscountedAmount
                                                "
                                                label="Afficher le montant après réduction"
                                                color="primary"
                                                class="pa-0"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.mainTableBox.style.hidden
                                                "
                                                data-cy="InvoiceThemeMenu-montantApresReduction"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex px-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.mainTableBox.rows
                                                        .crossNetAmount
                                                "
                                                color="primary"
                                                label="Barrer le montant HT"
                                                class="pa-0"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.mainTableBox.style
                                                        .hidden ||
                                                    !invoiceThemeSettings.mainTableBox.rows
                                                        .showDiscountedAmount
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex px-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.mainTableBox.rows
                                                        .showPercentDiscountAmount
                                                "
                                                color="primary"
                                                label="Afficher le montant de la réduction"
                                                class="pa-0"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.mainTableBox.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="py-3">
                                        <v-col cols="12" class="mb-2"
                                            ><span class="text-muted"
                                                >Couleurs du texte dans le tableau</span
                                            ></v-col
                                        >
                                        <v-col cols="4" class="d-flex px-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.mainTableBox
                                                        .automaticColors
                                                "
                                                color="primary"
                                                label="Automatique"
                                                class="pa-0"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.mainTableBox.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4" class="d-flex px-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings
                                                                        .mainTableBox.header.color
                                                                "
                                                                v-bind="props"
                                                                label="En-tête"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings
                                                                        .mainTableBox
                                                                        .automaticColors ||
                                                                    invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'mainTableBox.header.color',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                                <!-- <template #append>
                                                                    <v-btn icon text size=“x-small” @click.stop="invoiceThemeSettings.mainTableBox.header.color = ''">
                                                                        <v-icon  size=“x-small”>$fa-times</v-icon>
                                                                    </v-btn>
                                                                </template> -->
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="
                                                        invoiceThemeSettings.mainTableBox.header
                                                            .color
                                                    "
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.mainTableBox
                                                            .automaticColors ||
                                                        invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="4" class="d-flex px-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings
                                                                        .mainTableBox.rows.color
                                                                "
                                                                v-bind="props"
                                                                label="Lignes"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings
                                                                        .mainTableBox
                                                                        .automaticColors ||
                                                                    invoiceThemeSettings
                                                                        .mainTableBox.style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'mainTableBox.rows.color',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                                <!-- <template #append>
                                                                    <v-btn icon text size=“x-small” @click.stop="invoiceThemeSettings.mainTableBox.rows.color = ''">
                                                                        <v-icon  size=“x-small”>$fa-times</v-icon>
                                                                    </v-btn>
                                                                </template> -->
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="
                                                        invoiceThemeSettings.mainTableBox.rows.color
                                                    "
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.mainTableBox
                                                            .automaticColors ||
                                                        invoiceThemeSettings.mainTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.mainTableBox.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="mainTable-block"
                                        :unusedOptions="[
                                            'border',
                                            'borderColor',
                                            'backgroundColor',
                                            'color',
                                            'hidden',
                                        ]"
                                        :maxValues="{ borderRadius: mainTableBorderRadiusMax }"
                                        :disabled="invoiceThemeSettings.mainTableBox.style.hidden"
                                        @editing="editing"
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('deposits-block')"
                                data-cy="InvoiceThemeMenu-acomptes"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Acomptes</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="d-flex">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.depositsBox.style.hidden
                                                "
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.depositsBox.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="deposits-block"
                                        title="Options avancéees d'édition"
                                        :divider="false"
                                        @editing="editing"
                                        :unusedOptions="['hidden']"
                                        :disabled="invoiceThemeSettings.depositsBox.style.hidden"
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('totals-block')"
                                data-cy="InvoiceThemeMenu-recapitulatif"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Récapitulatif</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="d-flex">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.totalsBox.style.hidden
                                                "
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <!-- <v-col cols="6" class="d-flex flex-row align-center justify-center pl-2 mt-2 mb-2"> -->
                                        <!-- <v-checkbox
                                                v-model="showDiscount"
                                                label="Afficher la remise"
                                                color="primary"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox> -->
                                        <!-- <v-btn-toggle v-model="invoiceThemeSettings.summary.discountType"
                                                class="ml-2" mandatory="force"
                                            >
                                                <v-btn v-for="unit of discountTypes"
                                                        size=“x-small” :value="unit.value" :disabled="!showDiscount"
                                                >
                                                    <v-icon  size=“x-small”>{{ unit.faIcon }}</v-icon>
                                                </v-btn>
                                            </v-btn-toggle> -->
                                        <!-- </v-col> -->
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.totalsBox.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="totals-block"
                                        :divider="false"
                                        @editing="editing"
                                        :unusedOptions="['hidden']"
                                        :disabled="invoiceThemeSettings.totalsBox.style.hidden"
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('vatTable-block')"
                                data-cy="InvoiceThemeMenu-recapitulatifTVA"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Récapitulatif de TVA</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <!-- <v-col cols="7" class="d-flex pl-2 mb-2">
                                            <v-checkbox v-model="invoiceThemeSettings.vatTableBox.style.hidden"
                                                label="Cacher le bloc" density="compact"
                                                hide-details="auto">
                                            </v-checkbox>
                                        </v-col> -->
                                        <v-col cols="7" class="d-flex mb-2">
                                            <v-checkbox
                                                v-model="showVATSummary"
                                                label="Afficher un tableau récapitulatif"
                                                color="primary"
                                                density="compact"
                                                hide-details="auto"
                                                @update:model-value="
                                                    invoiceThemeSettings.vatTableBox.style.hidden =
                                                        !$event
                                                "
                                                data-cy="InvoiceThemeMenu-afficherUnTableauRecapitulatif"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="5" class="d-flex pl-2 mb-2">
                                            <VBtn
                                                class="ml-2"
                                                size="small"
                                                dark
                                                :disabled="
                                                    invoiceThemeSettings.vatTableBox.style.hidden
                                                "
                                                @click="copyMainTableSettings()"
                                                data-cy="InvoiceThemeMenu-copier"
                                            >
                                                <v-icon
                                                    icon="$fa-clone"
                                                    size="small"
                                                    class="mr-2"
                                                />
                                                <span style="font-size: 0.8em"
                                                    >Copier le tableau central</span
                                                >
                                            </VBtn>
                                            <v-snackbar
                                                v-model="tableConfCopySnackBar"
                                                color="success"
                                            >
                                                Configuration copiée avec succès!
                                                <template v-slot:actions>
                                                    <v-icon icon="$fa-check" />
                                                </template>
                                            </v-snackbar>
                                        </v-col>
                                    </v-row>

                                    <v-row no-gutters>
                                        <v-col cols="4" class="d-flex mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .header.backgroundColor
                                                                "
                                                                v-bind="props"
                                                                label="En-tête"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'vatTableBox.header.backgroundColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="
                                                        invoiceThemeSettings.vatTableBox.header
                                                            .backgroundColor
                                                    "
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .rows.backgroundColor
                                                                "
                                                                v-bind="props"
                                                                label="Lignes"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'vatTableBox.rows.backgroundColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="
                                                        invoiceThemeSettings.vatTableBox.rows
                                                            .backgroundColor
                                                    "
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="4" class="d-flex pl-3">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.vatTableBox.rows.border
                                                "
                                                color="primary"
                                                label="Bordures"
                                                :disabled="
                                                    invoiceThemeSettings.vatTableBox.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="4" class="d-flex pt-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <VTextFieldFilled
                                                        v-model="
                                                            invoiceThemeSettings.vatTableBox.rows
                                                                .borderColor
                                                        "
                                                        v-bind="props"
                                                        label="Bordures"
                                                        readonly
                                                        hide-details
                                                        :disabled="
                                                            invoiceThemeSettings.vatTableBox.style
                                                                .hidden
                                                        "
                                                        density="compact"
                                                    >
                                                        <template v-slot:prepend-inner>
                                                            <div
                                                                class="d-flex align-self-center"
                                                                :style="
                                                                    colorIconStyle(
                                                                        'vatTableBox.rows.borderColor',
                                                                    )
                                                                "
                                                            />
                                                        </template>
                                                    </VTextFieldFilled>
                                                </template>
                                                <v-color-picker
                                                    v-model="
                                                        invoiceThemeSettings.vatTableBox.rows
                                                            .borderColor
                                                    "
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <!-- Add options here -->
                                        <v-col cols="4" class="d-flex pt-2 pl-3">
                                            <VSelectFilled
                                                :items="tableRowsTypes"
                                                label="Mode de ligne du tableau"
                                                item-title="text"
                                                hide-details
                                                :disabled="
                                                    invoiceThemeSettings.vatTableBox.style.hidden
                                                "
                                                v-model="invoiceThemeSettings.vatTableBox.rows.mode"
                                                density="compact"
                                            >
                                            </VSelectFilled>
                                        </v-col>
                                        <v-col cols="4" class="d-flex pl-2 mt-2 mb-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .rows
                                                                        .secondaryBackgroundColor
                                                                "
                                                                v-bind="props"
                                                                label="Lignes (secondaire)"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .rows.mode !=
                                                                        'alternating' ||
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'vatTableBox.rows.secondaryBackgroundColor',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="
                                                        invoiceThemeSettings.vatTableBox.rows
                                                            .secondaryBackgroundColor
                                                    "
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <span class="text-muted">Colonnes</span>

                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <draggable
                                                        :list="vatTableColumns"
                                                        @change="onVATColumnsDraggableMove"
                                                        ghost-class="ghost"
                                                        itemKey=""
                                                        class="v-row v-row--no-gutters"
                                                    >
                                                        <template #item="{ element: column }">
                                                            <v-col
                                                                :key="column.value"
                                                                cols="12"
                                                                class="py-2"
                                                            >
                                                                <v-row
                                                                    no-gutters
                                                                    class="d-flex align-center justify-center"
                                                                >
                                                                    <div
                                                                        class="d-inline-block pr-1"
                                                                        style="cursor: move"
                                                                    >
                                                                        <v-icon
                                                                            icon="$fa-grip-vertical"
                                                                            size="small"
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        class="d-inline-block pl-1"
                                                                    >
                                                                        <v-checkbox
                                                                            v-model="column.checked"
                                                                            color="primary"
                                                                            class="pa-0"
                                                                            density="compact"
                                                                            hide-details="auto"
                                                                            :disabled="
                                                                                !column.optional ||
                                                                                invoiceThemeSettings
                                                                                    .vatTableBox
                                                                                    .style.hidden
                                                                            "
                                                                            @update:model-value="
                                                                                updateVATTableHeaderInTheme
                                                                            "
                                                                        >
                                                                        </v-checkbox>
                                                                    </div>
                                                                    <v-col class="px-2">
                                                                        <VTextFieldFilled
                                                                            v-model="column.text"
                                                                            :label="column.column"
                                                                            hide-details
                                                                            @update:model-value="
                                                                                updateVATTableHeaderInTheme
                                                                            "
                                                                            :disabled="
                                                                                invoiceThemeSettings
                                                                                    .vatTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            "
                                                                            density="compact"
                                                                        >
                                                                        </VTextFieldFilled>
                                                                    </v-col>
                                                                    <!-- <v-col class="px-2"> -->
                                                                    <div
                                                                        class="d-inline-block px-1"
                                                                    >
                                                                        <v-checkbox
                                                                            v-model="
                                                                                column.boldText
                                                                            "
                                                                            color="primary"
                                                                            label="Gras"
                                                                            density="compact"
                                                                            hide-details
                                                                            :disabled="
                                                                                invoiceThemeSettings
                                                                                    .vatTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            "
                                                                            @update:model-value="
                                                                                updateVATTableHeaderInTheme
                                                                            "
                                                                        >
                                                                        </v-checkbox>
                                                                    </div>
                                                                    <!-- </v-col> -->
                                                                    <!-- <v-col class="px-2"> -->
                                                                    <div
                                                                        class="d-inline-block px-1"
                                                                    >
                                                                        <v-btn-toggle
                                                                            mandatory="force"
                                                                            v-model="column.align"
                                                                            divided
                                                                            variant="outlined"
                                                                            @update:model-value="
                                                                                updateVATTableHeaderInTheme
                                                                            "
                                                                        >
                                                                            <v-btn-icon
                                                                                icon="$fa-align-left"
                                                                                value="left"
                                                                                size="x-small"
                                                                                variant="outlined"
                                                                            >
                                                                            </v-btn-icon>
                                                                            <v-btn-icon
                                                                                icon="$fa-align-center"
                                                                                value="center"
                                                                                size="x-small"
                                                                                variant="outlined"
                                                                            >
                                                                            </v-btn-icon>
                                                                            <v-btn-icon
                                                                                icon="$fa-align-right"
                                                                                value="right"
                                                                                size="x-small"
                                                                                variant="outlined"
                                                                            >
                                                                            </v-btn-icon>
                                                                        </v-btn-toggle>
                                                                    </div>
                                                                    <!-- </v-col> -->
                                                                    <v-col>
                                                                        <!-- <VTextFieldFilled
                                                                            v-model="column.width"
                                                                            label="Largeur %"
                                                                            density="compact"
                                                                            hide-details
                                                                            @update:model-value="updateVATTableHeaderInTheme"
                                                                        >
                                                                        </VTextFieldFilled> -->
                                                                        <CustomNumberField
                                                                            v-model="column.width"
                                                                            label="Largeur"
                                                                            :step="1"
                                                                            :min="1"
                                                                            :max="
                                                                                vatTableRemainingCellWidthPercent
                                                                            "
                                                                            placeholder="Auto"
                                                                            @change="
                                                                                (e) => {
                                                                                    vatTableCellInEditionWidth =
                                                                                        e;
                                                                                    updateVATTableHeaderInTheme();
                                                                                }
                                                                            "
                                                                            hide-details
                                                                            :disabled="
                                                                                invoiceThemeSettings
                                                                                    .vatTableBox
                                                                                    .style.hidden ||
                                                                                !column.checked
                                                                            "
                                                                        >
                                                                            <template #pre-append>
                                                                                <div
                                                                                    style="
                                                                                        font-size: small;
                                                                                        height: fit-content;
                                                                                        margin: auto;
                                                                                    "
                                                                                >
                                                                                    %
                                                                                </div>
                                                                            </template>
                                                                            <!-- <template #append-outer>
                                                                                <span class="text-small">mm</span>
                                                                            </template> -->
                                                                        </CustomNumberField>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </template>
                                                    </draggable>
                                                </v-col>
                                                <!-- <v-col cols="12" no-gutters class="d-flex align-center justify-start">
                                                    <v-btn
                                                        color="primary"
                                                        outlined
                                                        rounded
                                                        @click="addEmptyColumn"
                                                    >
                                                        <v-icon  size="small">$fa-plus</v-icon>
                                                        <span class="pl-2">Colonne</span>
                                                    </v-btn>
                                                </v-col> -->
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="py-3 mt-3">
                                        <v-col cols="12" class="mb-2"
                                            ><span class="text-muted"
                                                >Couleurs du texte dans le tableau</span
                                            ></v-col
                                        >
                                        <v-col cols="4" class="d-flex px-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.vatTableBox.automaticColors
                                                "
                                                color="primary"
                                                label="Automatique"
                                                class="pa-0"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.vatTableBox.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="4" class="d-flex px-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .header.color
                                                                "
                                                                v-bind="props"
                                                                label="En-tête"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .automaticColors ||
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'vatTableBox.header.color',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                                <!-- <template #append>
                                                                    <v-btn icon text size=“x-small” @click.stop="invoiceThemeSettings.vatTableBox.header.color = ''">
                                                                        <v-icon  size=“x-small”>$fa-times</v-icon>
                                                                    </v-btn>
                                                                </template> -->
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="
                                                        invoiceThemeSettings.vatTableBox.header
                                                            .color
                                                    "
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.vatTableBox
                                                            .automaticColors ||
                                                        invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="4" class="d-flex px-2">
                                            <v-menu offset-y :close-on-content-click="false">
                                                <template v-slot:activator="{ props }">
                                                    <v-row no-gutters>
                                                        <v-col cols="12">
                                                            <VTextFieldFilled
                                                                v-model="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .rows.color
                                                                "
                                                                v-bind="props"
                                                                label="Lignes"
                                                                readonly
                                                                hide-details
                                                                :disabled="
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .automaticColors ||
                                                                    invoiceThemeSettings.vatTableBox
                                                                        .style.hidden
                                                                "
                                                                density="compact"
                                                            >
                                                                <template v-slot:prepend-inner>
                                                                    <div
                                                                        class="d-flex align-self-center"
                                                                        :style="
                                                                            colorIconStyle(
                                                                                'vatTableBox.rows.color',
                                                                            )
                                                                        "
                                                                    />
                                                                </template>
                                                                <!-- <template #append>
                                                                    <v-btn icon text size=“x-small” @click.stop="invoiceThemeSettings.vatTableBox.rows.color = ''">
                                                                        <v-icon  size=“x-small”>$fa-times</v-icon>
                                                                    </v-btn>
                                                                </template> -->
                                                            </VTextFieldFilled>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <v-color-picker
                                                    v-model="
                                                        invoiceThemeSettings.vatTableBox.rows.color
                                                    "
                                                    show-swatches
                                                    mode="hexa"
                                                    hide-mode-switch
                                                    :swatches="swatches"
                                                    :disabled="
                                                        invoiceThemeSettings.vatTableBox
                                                            .automaticColors ||
                                                        invoiceThemeSettings.vatTableBox.style
                                                            .hidden
                                                    "
                                                >
                                                </v-color-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.vatTableBox.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="vatTable-block"
                                        :unusedOptions="[
                                            'border',
                                            'borderColor',
                                            'backgroundColor',
                                            'color',
                                            'hidden',
                                        ]"
                                        :disabled="invoiceThemeSettings.vatTableBox.style.hidden"
                                        :maxValues="{ borderRadius: vatTableBorderRadiusMax }"
                                        @editing="editing"
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('invoicePaymentDetails-block')"
                                data-cy="InvoiceThemeMenu-detailsPaiement"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Détails du paiement</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="d-flex">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.paymentDetailsBox.style
                                                        .hidden
                                                "
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.paymentDetailsBox.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="invoicePaymentDetails-block"
                                        title="Options avancéees d'édition"
                                        :divider="false"
                                        @editing="editing"
                                        :disabled="
                                            invoiceThemeSettings.paymentDetailsBox.style.hidden
                                        "
                                        :unusedOptions="['hidden']"
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('pagination-block')"
                                data-cy="InvoiceThemeMenu-pagination"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Pagination</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters class="d-flex align-center">
                                        <v-col cols="6" class="d-flex mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.paginationBox.style.hidden
                                                "
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.paginationBox.alwaysShow
                                                "
                                                color="primary"
                                                label="Toujours afficher la pagination"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.paginationBox.style.hidden
                                                "
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex mb-2 align-center">
                                            <span class="mr-2">Position</span>
                                            <v-btn-toggle
                                                mandatory="force"
                                                v-model="
                                                    invoiceThemeSettings.paginationBox.position
                                                "
                                                divided
                                                variant="outlined"
                                                density="comfortable"
                                            >
                                                <v-btn-icon
                                                    icon="$fa-align-left"
                                                    value="left"
                                                    size="small"
                                                    variant="outlined"
                                                >
                                                </v-btn-icon>
                                                <v-btn-icon
                                                    icon="$fa-align-center"
                                                    value="center"
                                                    size="small"
                                                    variant="outlined"
                                                >
                                                </v-btn-icon>
                                                <v-btn-icon
                                                    icon="$fa-align-right"
                                                    value="right"
                                                    size="small"
                                                    variant="outlined"
                                                >
                                                </v-btn-icon>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.paginationBox.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="pagination-block"
                                        title="Options avancéees d'édition"
                                        :divider="false"
                                        @editing="editing"
                                        :unusedOptions="['hidden']"
                                        :disabled="invoiceThemeSettings.paginationBox.style.hidden"
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing('invoiceFooterTextInner-block')"
                                data-cy="InvoiceThemeMenu-piedDePage"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Pied de page</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <v-col cols="6" class="d-flex mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.footerContentBox.style
                                                        .hidden
                                                "
                                                color="primary"
                                                label="Cacher le bloc"
                                                density="compact"
                                                hide-details="auto"
                                                data-cy="InvoiceThemeMenu-piedDePageCacherBloc"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.style.displayFooterDivider
                                                "
                                                label="Afficher le trait de séparation"
                                                color="primary"
                                                density="compact"
                                                hide-details="auto"
                                                :disabled="
                                                    invoiceThemeSettings.footerContentBox.style
                                                        .hidden
                                                "
                                                data-cy="InvoiceThemeMenu-afficherLeTraitDeSeparation"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <AdvancedBoxEditor
                                        v-model="invoiceThemeSettings.footerContentBox.style"
                                        v-if="invoiceThemeSettings.useAdvancedStyling"
                                        :perRow="2"
                                        editedElementClass="invoiceFooterTextInner-block"
                                        @editing="editing"
                                        :unusedOptions="['hidden']"
                                        :disabled="
                                            invoiceThemeSettings.footerContentBox.style.hidden
                                        "
                                    >
                                    </AdvancedBoxEditor>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing(null)"
                                data-cy="InvoiceThemeMenu-pagesSuivantes"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Pages suivantes</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="mt-2 mb-2">
                                            <span
                                                >Les éléments sélectionnés seront répétés sur les
                                                nouvelles pages.</span
                                            >
                                        </v-col>
                                        <v-col cols="6" class="d-flex mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .header
                                                "
                                                color="primary"
                                                label="Entête"
                                                density="compact"
                                                hide-details="auto"
                                                @click="editing('invoiceHeader-block')"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .footer
                                                "
                                                color="primary"
                                                label="Pied de page"
                                                density="compact"
                                                hide-details="auto"
                                                @click="editing('invoiceFooterTextInner-block')"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .emitter
                                                "
                                                color="primary"
                                                label="Emetteur"
                                                density="compact"
                                                hide-details="auto"
                                                @click="editing('emitter-block')"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .receiver
                                                "
                                                color="primary"
                                                label="Destinataire"
                                                density="compact"
                                                hide-details="auto"
                                                @click="editing('receiver-block')"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .titleBox
                                                "
                                                color="primary"
                                                label="Infos de la facture"
                                                density="compact"
                                                hide-details="auto"
                                                @update:model-value="
                                                    handleTitleCheckBoxChange($event)
                                                "
                                                @click="editing('invoiceTitle-block')"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.page.repeatOnFollowingPages
                                                        .invoiceNumberBox
                                                "
                                                color="primary"
                                                label="Numéro de la facture"
                                                density="compact"
                                                hide-details="auto"
                                                @update:model-value="
                                                    handleInvoiceNumberCheckBoxChange($event)
                                                "
                                                @click="editing('invoiceTitle-block')"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel
                                @click="editing(null)"
                                data-cy="InvoiceThemeMenu-annexe"
                            >
                                <v-expansion-panel-title class="pa-2">
                                    <v-row no-gutters class="align-center my-2">
                                        <b>Annexe</b>
                                        <v-col class="d-flex align-center px-3">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-title>
                                <v-expansion-panel-text>
                                    <v-row no-gutters>
                                        <v-col cols="6" class="d-flex pl-2 mt-2 mb-2">
                                            <v-checkbox
                                                v-model="
                                                    invoiceThemeSettings.appendix.includeAppendix
                                                "
                                                label="Joindre une annexe"
                                                color="primary"
                                                density="compact"
                                                hide-details="auto"
                                                data-cy="InvoiceThemeMenu-joindreUneAnnexe"
                                            >
                                            </v-checkbox>
                                        </v-col>
                                        <v-col cols="6" class="d-flex flex-column pl-2 mt-2 mb-2">
                                            <div class="d-flex flex-row">
                                                <v-btn
                                                    variant="outlined"
                                                    rounded="lg"
                                                    @click="openInvoiceAppendixUploadDialog"
                                                    :disabled="
                                                        !invoiceThemeSettings.appendix
                                                            .includeAppendix
                                                    "
                                                    data-cy="InvoiceThemeMenu-changer"
                                                >
                                                    <span class="mx-2">Changer</span>
                                                    <v-icon size="small" icon="$oss-upload" />
                                                </v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-text>
                                <oss-dialog
                                    v-model="invoiceAppendixUploadDialog"
                                    v-if="invoiceAppendixUploadDialog"
                                    title="Importer une annexe"
                                    :actions="appendixActions"
                                    max-width="900"
                                >
                                    <UploadDocuments
                                        key="appendix"
                                        :companyId="companyId"
                                        :documentType="'BOOKLET_TEMPLATE'"
                                        :multiple="false"
                                        :freeTag="false"
                                        :actions="appendixActions"
                                        :showActionsBtn="false"
                                        :inExtensions="['pdf']"
                                        @file="updateInvoiceAppendix($event)"
                                        @file-uploaded="invoiceAppendixUploadDialog = false"
                                    />
                                </oss-dialog>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
            </v-tabs-window-item>
            <v-tabs-window-item
                key="showInformationsTab"
                value="showInformationsTab"
                class="fill-height ml-2 mr-2"
            >
                <v-row no-gutters>
                    <v-col cols="12">
                        <CompanyLogo :companyId="companyId" />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <LegalForm :companyId="companyId" @changed-info="onLegalFormInfoChanged" />
                    </v-col>
                </v-row>
            </v-tabs-window-item>
            <v-tabs-window-item
                key="showAdvanceSettingsTab"
                value="showAdvanceSettingsTab"
                class="fill-height ml-2 mr-2"
            >
                <InvoiceAdvanceSetting :companyId="companyId"> </InvoiceAdvanceSetting>
            </v-tabs-window-item>
        </v-tabs-window>
    </v-row>
</template>
<script lang="ts">
import Logo from "../configuration/Logo.vue";
import LegalForm from "../configuration/LegalForm.vue";
import InvoiceAdvanceSetting from "../invoice/advanceSetting/InvoiceAdvanceSetting.vue";
import CustomNumberField from "./CustomNumberField.vue";
import AdvancedBoxEditor from "./AdvancedBoxEditor.vue";

import draggable from "vuedraggable";
import InvoiceThemeService from "../../../../backend/src/common/invoiceTheme/invoiceThemeService";
import UploadDocuments from "../document/UploadDocuments.vue";
import UPDATE_INVOICE_THEME_BACKGROUND from "@/graphql/invoiceTheme/UpdateInvoiceThemeBackground.gql";
import UPDATE_INVOICE_THEME_ADDITIONAL_DOCUMENT from "@/graphql/invoiceTheme/UpdateInvoiceThemeAdditionalDocument.gql";
import GET_INVOICE_THEME_BACKGROUND from "@/graphql/invoiceTheme/GetInvoiceThemeBackground.gql";
import { DialogAction } from "../../services/dialogAction";

import { availableThemes } from "../../../../backend/src/common/invoiceTheme/defaultThemes";
import InvoiceThemeFrontService from "@/services/invoiceThemeFrontServices";
import _ from "lodash";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        CompanyLogo: Logo,
        LegalForm,
        InvoiceAdvanceSetting,
        draggable,
        UploadDocuments,
        CustomNumberField,
        AdvancedBoxEditor,
    },
    emits: [
        "settings-change",
        "header-update",
        "upsert-invoice-theme",
        "pdf-preview",
        "font-hover",
        "background-image",
        "additional-document",
        "editing",
        "reset-personalized",
        "theme-selected",
        "document-type-selected",
        "saved-legal-form-info",
        "changed-legal-form-info",
    ],
})
export class ExportThemeMenu extends Vue {
    @Prop({ default: null }) companyId: string;
    @Prop({ default: true }) showFirstPageSettings!: boolean;
    @Prop({ default: true }) showNextSettings!: boolean;
    @Prop({ default: true }) showStyleSettings!: boolean;
    @Prop({ default: null }) initialInvoiceThemeSettings: any;
    @Prop({ default: true }) showInformationsTab!: boolean;
    @Prop({ default: true }) showInvoiceThemeTab!: boolean;
    @Prop({ default: null }) idTheme: string;
    @Prop({ default: null }) radioButtonValue: boolean;

    invoiceThemeSettings_: any = "";

    get invoiceThemeSettings() {
        if (!this.invoiceThemeSettings_ && !this.initialInvoiceThemeSettings) {
            return {};
        } else if (!this.invoiceThemeSettings_ && this.initialInvoiceThemeSettings) {
            this.invoiceThemeSettings_ = _.merge({}, this.initialInvoiceThemeSettings);
        }
        return this.invoiceThemeSettings_;
    }

    set invoiceThemeSettings(newVal) {
        this.invoiceThemeSettings_ = _.merge(this.invoiceThemeSettings_, newVal);
    }

    debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }

    debounceChangesEmit: (...args) => void = null; // Initialized in beforeMount to avoid null this.$emit error

    @Watch("invoiceThemeSettings", { deep: true })
    emitSettingsChange() {
        if (this.debounceChangesEmit) {
            this.debounceChangesEmit();
        }
    }

    @Watch("initialInvoiceThemeSettings")
    updateInitialSettings(val) {
        if (this.initialInvoiceThemeSettings) {
            this.invoiceThemeSettings_ = _.merge({}, this.initialInvoiceThemeSettings);
            if (this.invoiceThemeSettings_?.name === "Personal") {
                // Put selector on Personal theme widget
                this.selectedThemeSettings = { name: "Personal" };
            }
        }
    }

    onLegalFormInfoSaved(info: {
        companyId?: string;
        paymentDetails?: string;
        legalNotices?: string;
        paymentMode?: string;
    }) {
        this.$emit("saved-legal-form-info", info);
    }

    onLegalFormInfoChanged(info: {
        companyId?: string;
        paymentDetails?: string;
        legalNotices?: string;
        paymentMode?: string;
    }) {
        this.$emit("changed-legal-form-info", info);
    }

    activeTabStyle = "";

    // isDefaultThemeSelected = false

    mainTableCellInEditionWidth_ = 0; // Width of the cell being edited

    vatTableCellInEditionWidth_ = 0; // Width of the cell being edited

    mainTableBorderRadiusMax = 8;
    vatTableBorderRadiusMax = 6;

    set vatTableCellInEditionWidth(val) {
        let newVal = Math.max(0, val);
        newVal = Math.min(100, newVal);
        this.vatTableCellInEditionWidth_ = newVal;
    }

    get vatTableCellInEditionWidth() {
        return this.vatTableCellInEditionWidth_;
    }

    set mainTableCellInEditionWidth(val) {
        let newVal = Math.max(0, val);
        newVal = Math.min(100, newVal);
        this.mainTableCellInEditionWidth_ = newVal;
    }

    get mainTableCellInEditionWidth() {
        return this.mainTableCellInEditionWidth_;
    }

    defaultBackgroundsDataList = [];

    tableConfCopySnackBar = false;

    get mainTableRemainingCellWidthPercent() {
        // let val = 100
        // try {
        //     val = this.tableColumns.reduce((total, column) => column.checked ? total - this.removePercentSign(column.width, true) : total, 100)
        //     val = Math.max(0, val)
        // } catch (error) {
        //     console.error(error)
        // }
        // val += Number(this.mainTableCellInEditionWidth)
        // val = Math.min(val, 100)
        // return val
        return 100;
    }

    get vatTableRemainingCellWidthPercent() {
        // let val = 100
        // try {
        //     val = this.vatTableColumns.reduce((total, column) => column.checked ? total - this.removePercentSign(column.width, true) : total, 100)
        //     val = Math.max(0, val)
        // } catch (error) {
        //     console.error(error)
        // }
        // val += Number(this.vatTableCellInEditionWidth)
        // val = Math.min(val, 100)
        // return val
        return 100;
    }

    // getMax(currentVal) {
    //     console.log("currentVal", currentVal)
    //     return Number(currentVal ?? 0) + this.mainTableRemainingCellWidthPercent
    // }

    removePercentSign(perc, toNumber = true) {
        if (typeof perc !== "string") {
            return perc;
        }
        const val = perc.replaceAll("%", "");
        if (toNumber) {
            try {
                return Number(val);
            } catch (error) {
                console.error(error);
            }
        }
        return val;
    }

    async beforeMount() {
        this.debounceChangesEmit = this.debounce(
            () => this.$emit("settings-change", this.invoiceThemeSettings),
            200,
        );

        const urlsData = await InvoiceThemeFrontService.fetchDefaultBackgrounds(
            InvoiceThemeService.getDefaultBackgroundsUris().map((x) => x.fileKey),
        );
        for (const img of InvoiceThemeService.getDefaultBackgroundsUris()) {
            const urlData = urlsData.find((x) => x.fileKey === img.fileKey);
            if (urlData) {
                this.defaultBackgroundsDataList.push({
                    ...img,
                    ...urlData,
                });
            }
        }
    }

    activeTabInvoiceTheme: "showInformationsTab" | "showInvoiceThemeTab" = "showInformationsTab";

    position = [
        { value: "", text: "Sans" },
        { value: "top-left", text: "Haut Gauche" },
        { value: "top-right", text: "Haut Droite" },
        { value: "bottom-left", text: "Bas Gauche" },
        { value: "bottom-right", text: "Bas Droite" },
    ];

    positionClient = [{ value: "center", text: "Centré" }];

    fontWeight = [
        { value: "normal", text: "Normal" },
        { value: "bold", text: "Gras" },
    ];

    fontFamily = [
        { value: "serif", text: "Serif" },
        { value: "sans-serif", text: "Sans serif" },
        { value: "Georgia", text: "Georgia" },
        { value: "system-ui", text: "System UI" },
        { value: "Arial", text: "Arial" },
        // {value:"Helvetica",text:"Helvetica"},
    ];

    swatches = [
        // ['#1abc9c','#2ecc71','#16a085','#95a5a6','#7f8c8d'],
        // ['#27ae60','#3498db','#2980b9','#c0392b','#ecf0f1'],
        // ['#9b59b6','#8e44ad','#34495e','#e67e22','#e74c3c'],
        // ['#2c3e50','#f1c40f','#f39c12','#d35400','#bdc3c7'],
        ["#b2e2f2ff", "#b0c2f2ff", "#84b6f4ff"],
        ["#77dd77ff", "#b0f2c2ff", "#d8f8e1ff"],
        ["#fcb7afff", "#fabfb7ff", "#ffe4e1ff"],
        ["#fdfd96ff", "#ffda9eff", "#fdf9c4ff"],
        ["#ffffffff", "#f5f5f5ff", "#efefefff"],
        ["#00000000"],
    ];

    discountTypes = [
        {
            text: "Pourcentage",
            value: "percent",
            faIcon: "$fa-percent",
        },
        {
            text: "Montant",
            value: "amount",
            faIcon: "$fa-euro-sign",
        },
    ];
    // TODO Add external border and border type like dashed or solid

    tableRowsTypes = [
        {
            text: "Par défaut",
            value: "default",
        },
        {
            text: "Simple",
            value: "simple",
        },
        {
            text: "Couleurs alternées",
            value: "alternating",
        },
    ];

    previewDocumentTypes = [
        {
            title: "Facture",
            value: "Facture",
        },
        {
            title: "Devis",
            value: "Devis",
        },
        {
            title: "Facture avec acomptes",
            value: "FactureAvecAcomptes",
        },
        {
            title: "Facture avec remises",
            value: "FactureAvecRemises",
        },
        {
            title: "Bordereau de livraison",
            value: "Bordereau",
        },
        {
            title: "Acomptes",
            value: "Acompte",
        },
        {
            title: "Inventaire de stock",
            value: "InventaireStock",
        },
    ];

    selectedPreviewDocumentType = "Facture";

    get showLogo() {
        return !this.invoiceThemeSettings.headerContentBox.iconBox.style.hidden;
    }

    set showLogo(val) {
        this.invoiceThemeSettings.headerContentBox.iconBox.style.hidden = !val;
    }

    getDefaultBackgroundsUris() {
        return InvoiceThemeService.getDefaultBackgroundsUris();
    }

    get getAvailableThemes() {
        return availableThemes;
    }

    get tableColumns() {
        return (
            this.invoiceThemeSettings?.tables?.header?.columns ||
            InvoiceThemeService.getDefaultTableColumns()
        );
    }

    set tableColumns(val) {
        if (this.invoiceThemeSettings?.tables?.header) {
            this.invoiceThemeSettings.tables.header.columns = val;
        }
    }

    get horizontalMargin() {
        return this.invoiceThemeSettings?.page?.horizontalMargin ?? 1;
    }

    set horizontalMargin(val) {
        if (this.invoiceThemeSettings.page) {
            this.invoiceThemeSettings.page.horizontalMargin = val;
        }
    }

    get verticalMargin() {
        return this.invoiceThemeSettings?.page?.verticalMargin ?? 1;
    }

    set verticalMargin(val) {
        if (this.invoiceThemeSettings.page) {
            this.invoiceThemeSettings.page.verticalMargin = val;
        }
    }

    marginLabels = ["Petite", "Normale", "Grande", "Très grande"];
    fonts = [
        "Par défaut",
        "Arial",
        "Calibri",
        "Helvetica",
        "Lato",
        "Mulish",
        "Roboto",
        "Tahoma",
        "Times New Roman",
        "Verdana",
    ];
    maxFontSizeMap = {
        "Par défaut": 14,
        Arial: 13,
        Calibri: 14,
        "Courier Prime": 14,
        Helvetica: 13,
        Lato: 13,
        Mulish: 14,
        Roboto: 14,
        Tahoma: 13,
        "Times New Roman": 14,
        Verdana: 12,
    };

    get maxFontSize() {
        return this.maxFontSizeMap?.[this.selectedFontFamily] ?? 13;
    }

    get selectedFontFamily() {
        const themeFont = this.invoiceThemeSettings?.page?.fontFamily;
        if (!this.fonts.includes(themeFont)) {
            return "Par défaut";
        }
        return themeFont;
    }

    set selectedFontFamily(val) {
        if (this.invoiceThemeSettings.page) {
            this.invoiceThemeSettings.page.fontFamily = this.fonts.includes(val)
                ? val
                : "Circular Std Book";
        }
    }

    get selectedFontSize() {
        const themeFontSize = this.invoiceThemeSettings?.page?.fontSize || 11;
        return themeFontSize;
    }

    set selectedFontSize(val) {
        if (this.invoiceThemeSettings.page) {
            // this.invoiceThemeSettings.page.fontSize = Math.max(val, 6)
            const oldVal = this.invoiceThemeSettings.page.fontSize || 11;
            this.invoiceThemeSettings.page.fontSize = Math.max(0, parseInt(val) || oldVal);
            this.invoiceThemeSettings.page.fontSize = Math.min(
                this.invoiceThemeSettings.page.fontSize,
                32,
            );
        }
    }

    get logoSizeMultiplier() {
        // const size = this.invoiceThemeSettings?.style?.logoSizeMultiplier || 1
        const size = this.invoiceThemeSettings?.headerContentBox?.iconBox?.logoSizeMultiplier || 1;
        return size * 100;
    }

    set logoSizeMultiplier(val) {
        if (this.invoiceThemeSettings?.headerContentBox?.iconBox) {
            this.invoiceThemeSettings.headerContentBox.iconBox.logoSizeMultiplier =
                Math.max(val, 0) / 100;
            this.invoiceThemeSettings.headerContentBox.iconBox.logoSizeMultiplier =
                Math.min(val, 500) / 100;
        }
    }

    get showDiscount() {
        return Boolean(this.invoiceThemeSettings?.summary?.showDiscount);
    }

    set showDiscount(val) {
        if (this.invoiceThemeSettings?.summary) {
            this.invoiceThemeSettings.summary.showDiscount = val;
        }
    }

    get showVATSummary() {
        return this.invoiceThemeSettings?.summary?.showVATSummary || false;
    }

    set showVATSummary(val) {
        if (this.invoiceThemeSettings?.summary) {
            this.invoiceThemeSettings.summary.showVATSummary = val;
        }
    }

    get vatTableColumns() {
        return (
            this.invoiceThemeSettings?.summary?.vatTable?.columns ||
            InvoiceThemeService.getDefaultVATTableColumns()
        );
    }

    set vatTableColumns(val) {
        if (this.invoiceThemeSettings?.summary?.vatTable) {
            this.invoiceThemeSettings.summary.vatTable.columns = val;
        }
    }

    backgroundSizeItems = [
        { value: "auto", title: "Auto" },
        { value: "cover", title: "Couvrir" },
        { value: "contain", title: "Contenir" },
    ];

    backgroundPositionItems = [
        { value: "top", title: "En haut" },
        { value: "center", title: "Au centre" },
        { value: "bottom", title: "En bas" },
    ];

    backgroundRepeatItems = [
        { value: "repeat", title: "Répéter" },
        { value: "no-repeat", title: "Ne pas répéter" },
        { value: "repeat-x", title: "Répéter horizontalement" },
        { value: "repeat-y", title: "Répéter verticalement" },
    ];

    get emitterBorderColor() {
        return InvoiceThemeService.formatColorToHexa(
            this.invoiceThemeSettings?.emitter?.style?.borderColor,
        );
    }

    set emitterBorderColor(val) {
        if (this.invoiceThemeSettings?.emitter?.style?.borderColor) {
            this.invoiceThemeSettings.emitter.style.borderColor = val;
        }
    }

    get emitterBgColor() {
        return InvoiceThemeService.formatColorToHexa(
            this.invoiceThemeSettings?.emitter?.style?.backgroundColor,
        );
    }

    set emitterBgColor(val) {
        if (this.invoiceThemeSettings?.emitter?.style?.backgroundColor) {
            this.invoiceThemeSettings.emitter.style.backgroundColor = val;
        }
    }

    get receiverBorderColor() {
        return InvoiceThemeService.formatColorToHexa(
            this.invoiceThemeSettings.receiver.style.borderColor,
        );
    }

    set receiverBorderColor(val) {
        if (this.invoiceThemeSettings?.receiver?.style?.borderColor) {
            this.invoiceThemeSettings.receiver.style.borderColor = val;
        }
    }

    get receiverBgColor() {
        return InvoiceThemeService.formatColorToHexa(
            this.invoiceThemeSettings?.receiver?.style?.backgroundColor,
        );
    }

    set receiverBgColor(val) {
        if (this.invoiceThemeSettings?.receiver?.style?.backgroundColor) {
            this.invoiceThemeSettings.receiver.style.backgroundColor = val;
        }
    }

    get tableHeaderBgColor() {
        return InvoiceThemeService.formatColorToHexa(
            this.invoiceThemeSettings?.tables?.header?.backgroundColor,
        );
    }

    set tableHeaderBgColor(val) {
        if (this.invoiceThemeSettings?.tables?.header?.backgroundColor) {
            this.invoiceThemeSettings.tables.header.backgroundColor = val;
        }
    }

    // get vatTableHeaderBgColor() {
    //     return InvoiceThemeService.formatColorToHexa(this.invoiceThemeSettings?.vatTableBox?.header?.backgroundColor)
    // }

    // set vatTableHeaderBgColor(val) {
    //     if (this.invoiceThemeSettings?.vatTableBox?.header?.backgroundColor) {
    //         this.invoiceThemeSettings.vatTableBox.header.backgroundColor = val
    //     }
    // }

    get tableRowBgColor() {
        return InvoiceThemeService.formatColorToHexa(
            this.invoiceThemeSettings?.tables?.rows?.backgroundColor,
        );
    }

    set tableRowBgColor(val) {
        if (this.invoiceThemeSettings?.tables?.rows?.backgroundColor) {
            this.invoiceThemeSettings.tables.rows.backgroundColor = val;
        }
    }

    get tableRowBorderColor() {
        return InvoiceThemeService.formatColorToHexa(
            this.invoiceThemeSettings?.tables?.rows?.borderColor,
        );
    }

    set tableRowBorderColor(val) {
        if (this.invoiceThemeSettings?.tables?.rows?.borderColor) {
            this.invoiceThemeSettings.tables.rows.borderColor = val;
        }
    }

    get logoOnRightSide() {
        return this.invoiceThemeSettings?.headerContentBox?.iconBox?.iconPosition === "right";
    }

    set logoOnRightSide(val) {
        if (this.invoiceThemeSettings?.headerContentBox?.iconBox?.iconPosition) {
            this.invoiceThemeSettings.headerContentBox.iconBox.iconPosition = val
                ? "right"
                : "left";
        }
    }

    onDraggableMove() {
        this.updateTableHeaderInTheme();
    }

    onVATColumnsDraggableMove() {
        this.updateVATTableHeaderInTheme();
    }

    // get defaultFaultTableColumns() {
    //     return [
    //         {checked: true, optional: false, text: 'Produit', value: 'product', align: 'left', width: "50"},
    //         {checked: true, optional: false, text: 'Quantité', value: 'quantity', align: 'center', width: "5"},
    //         {checked: true, optional: false, text: 'Prix unitaire', value: 'unitPrice', align: 'center', width: "20"},
    //         {checked: true, optional: false, text: 'TVA', value: 'vat', align: 'center', width: "5"},
    //         {checked: true, optional: false, text: 'Montant HT', value: 'netAmount', align: 'right', width: "20"},
    //     ]
    // }

    // addEmptyColumn() {
    //     this.tableColumns.push(
    //         {checked: true, optional: true, text: "", value: `column${this.tableColumns.length}`, align: 'left', width: ""}
    //     )
    //     this.updateTableHeaderInTheme()
    // }

    updateTableHeaderInTheme() {
        this.invoiceThemeSettings.tables.header.columns = JSON.parse(
            JSON.stringify(this.tableColumns),
        );
        // this.$emit("header-update", this.tableColumns)
    }

    updateVATTableHeaderInTheme() {
        this.invoiceThemeSettings.summary.vatTable.columns = JSON.parse(
            JSON.stringify(this.vatTableColumns),
        );
    }

    // get companyId() {
    //     if (this.$route.params.id) {
    //         return this.$route.params.id;
    //     } else if (this.$route.params.companyId) {
    //         return this.$route.params.companyId
    //     }
    //     return ""
    // }

    // @Watch('radioButtonValue')
    // radioButtonValueChange() {
    //     this.isDefaultThemeSelected = this.radioButtonValue
    // }

    // @Watch('activeTab')
    // emitActiveTab(){
    //     debugger
    //     this.$emit('emit-step', this.activeTab)
    // }

    // @Watch('activeTabStyle')
    // emitActiveTabStyle(){
    //     debugger
    //     this.$emit('emit-step', this.activeTabStyle)
    // }

    checkPositionAvailable(position, key) {
        debugger;

        // console.log(position)

        for (const pos in this.invoiceThemeSettings.pages.position) {
            if (!(pos === key)) {
                if (this.invoiceThemeSettings.pages.position[pos] === position) {
                    this.invoiceThemeSettings.pages.position[pos] = "";
                }
            }

            console.log(pos + " " + this.invoiceThemeSettings.pages.position[pos]);
        }
    }

    colorIconStyle(string) {
        return {
            height: "20px",
            width: "20px",
            "border-radius": "10px",
            "z-index": "1",
            "background-color":
                this.deepObjectFromStringKey(this.invoiceThemeSettings, string) || "",
        };
    }

    deepObjectFromStringKey(object: Object, string: string) {
        const index = string.indexOf(".");
        if (index === -1) {
            return object[string];
        }
        if (object[string.substring(0, index)]) {
            return this.deepObjectFromStringKey(
                object[string.substring(0, index)],
                string.substring(index + 1),
            );
        }
        return undefined;
    }

    emitSaveTheme(optionalCallback = null) {
        this.$emit("upsert-invoice-theme", optionalCallback);
    }

    emitPDFPreview() {
        this.$emit("pdf-preview");
    }

    hoveredFont = this.selectedFontFamily;

    handleFontSelectChange(font) {
        this.selectedFontFamily = font;
        this.hoveredFont = null;
        this.$emit("font-hover", null);
    }

    onFontMouseOver(font) {
        this.hoveredFont = font;
        // console.log("this.hoveredFont", this.hoveredFont)
        // this.$emit("font-hover", this.hoveredFont)
    }

    onFontMouseLeave(font) {
        // this.hoveredFont = null
        this.$emit("font-hover", null);
        // console.log("onFontMouseLeave", font)
    }

    get hiddenUnusedOption(): string[] {
        return ["hidden"];
    }

    invoiceBgUploadDialog = false;
    invoiceAppendixUploadDialog = false;

    openInvoiceBgUploadDialog() {
        this.actions.action.display = false;
        this.actions.action.loading = false;
        this.invoiceBgUploadDialog = true;
    }

    openInvoiceAppendixUploadDialog() {
        this.actions.action.display = false;
        this.actions.action.loading = false;
        this.invoiceAppendixUploadDialog = true;
    }

    actions = {
        action: new DialogAction(),
    };

    appendixActions = {
        action: new DialogAction(),
    };

    async updateInvoiceBackground_(eventData = null) {
        this.updateInvoiceBackgroundWithId(eventData, this.idTheme);
    }

    async updateInvoiceBackgroundWithId(eventData = null, id = "") {
        if (id && eventData?.file) {
            this.actions.action.loading = true;

            const response = await this.$apollo.mutate({
                mutation: UPDATE_INVOICE_THEME_BACKGROUND,
                variables: {
                    id: id,
                    file: eventData.file,
                },
            });
            this.personalizedBgImage = response?.data?.updateInvoiceThemeBackground?.signedUrl;
            if (!this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
                this.$emit("background-image", response?.data?.updateInvoiceThemeBackground);
            }
            this.invoiceBgUploadDialog = false;
            this.actions.action.loading = false;
        } else {
            debugger;
        }
    }

    async updateInvoiceBackground(eventData = null) {
        if (!this.idTheme) {
            this.emitSaveTheme((newlySavedThemeId) =>
                this.updateInvoiceBackgroundWithId(eventData, newlySavedThemeId),
            );
        } else {
            this.updateInvoiceBackground_(eventData);
        }
    }

    async updateInvoiceAppendix_(eventData = null) {
        this.updateInvoiceAppendixWithId(eventData, this.idTheme);
    }

    async updateInvoiceAppendixWithId(eventData = null, id = "") {
        if (id && eventData?.file) {
            this.appendixActions.action.loading = true;

            const response = await this.$apollo.mutate({
                mutation: UPDATE_INVOICE_THEME_ADDITIONAL_DOCUMENT,
                variables: {
                    id: id,
                    file: eventData.file,
                },
            });
            this.$emit("additional-document", response?.data?.updateInvoiceThemeAdditionalDocument);
            this.invoiceAppendixUploadDialog = false;
            this.appendixActions.action.loading = false;
        } else {
            debugger;
        }
    }

    async updateInvoiceAppendix(eventData = null) {
        if (!this.idTheme) {
            this.emitSaveTheme((newlySavedThemeId) =>
                this.updateInvoiceAppendixWithId(eventData, newlySavedThemeId),
            );
        } else {
            this.updateInvoiceAppendix_(eventData);
        }
    }

    selectDefaultBackground(identifier: string) {
        if (
            this.invoiceThemeSettings?.page &&
            this.invoiceThemeSettings?.page?.useBackgroundImage
        ) {
            this.invoiceThemeSettings.page.selectedDefaultBackgroundKey = identifier;
            const bgData = this.defaultBackgroundsDataList.find((x) => x.fileKey === identifier);
            if (bgData?.signedUrl) {
                this.$emit("background-image", bgData);
            } else {
                // debugger
            }
        }
    }

    isDefaultBackgroundSelected(identifier: string) {
        return (
            this.invoiceThemeSettings.page.selectedDefaultBackgroundKey === identifier &&
            this.invoiceThemeSettings?.page?.useBackgroundImage
        );
    }

    selectPersonalizedBackground() {
        if (
            this.invoiceThemeSettings?.page &&
            this.invoiceThemeSettings?.page?.useBackgroundImage
        ) {
            this.invoiceThemeSettings.page.selectedDefaultBackgroundKey = null;
            if (this.personalizedBgImage) {
                this.$emit("background-image", { signedUrl: this.personalizedBgImage });
            } else {
                // debugger
            }
        }
    }

    get isPersonalizedBackgroundSelected() {
        return (
            !this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey &&
            this.personalizedBgImage &&
            this.invoiceThemeSettings?.page?.useBackgroundImage
        );
    }

    personalizedBgImage: any = null;

    @Watch("invoiceThemeSettings", { deep: true })
    async fetchBackgroundImage() {
        // if (this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey) {
        //     return
        // }
        if (!this.invoiceThemeSettings?.page?.useBackgroundImage || this.personalizedBgImage) {
            return;
        }
        if (!this.idTheme || this.idTheme.length === 0) {
            this.personalizedBgImage = null;
            return;
        }

        const response = await this.$apollo.query({
            query: GET_INVOICE_THEME_BACKGROUND,
            variables: {
                id: this.idTheme,
            },
        });

        if (!response?.data?.getInvoiceThemeBackground?.signedUrl) {
            // debugger
            this.personalizedBgImage = null;
            return;
        }
        this.personalizedBgImage = response.data.getInvoiceThemeBackground.signedUrl;
        // this.selectPersonalizedBackground()

        if (
            this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey &&
            this.invoiceThemeSettings?.page?.useBackgroundImage
        ) {
            this.selectDefaultBackground(
                this.invoiceThemeSettings.page.selectedDefaultBackgroundKey,
            );
        } else if (
            !this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey &&
            this.invoiceThemeSettings?.page?.useBackgroundImage
        ) {
            this.selectPersonalizedBackground();
        }
    }

    updated() {
        if (
            this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey &&
            this.invoiceThemeSettings?.page?.useBackgroundImage
        ) {
            this.selectDefaultBackground(
                this.invoiceThemeSettings.page.selectedDefaultBackgroundKey,
            );
        } else if (
            !this.invoiceThemeSettings?.page?.selectedDefaultBackgroundKey &&
            this.invoiceThemeSettings?.page?.useBackgroundImage
        ) {
            this.selectPersonalizedBackground();
        }
    }

    editing(editedElementClass) {
        if (editedElementClass) {
            this.$emit("editing", editedElementClass);
        } else {
            this.$emit("editing", "no-class");
        }
    }

    selectedThemeSettings_: any = "";

    get selectedThemeSettings() {
        if (this.invoiceThemeSettings && !this.selectedThemeSettings_) {
            return { name: this.invoiceThemeSettings.name };
        }
        return this.selectedThemeSettings_;
    }

    set selectedThemeSettings(settings) {
        this.selectedThemeSettings_ = JSON.parse(JSON.stringify(settings));
    }

    selectTheme(theme) {
        if (theme?.name === "Personal") {
            // Restore user personal theme
            this.$emit("reset-personalized");
            this.selectedThemeSettings = { name: "Personal" };
            if (this.personalizedBgImage) {
                this.$emit("background-image", { signedUrl: this.personalizedBgImage });
            }
        } else if (theme?.name !== "Personal") {
            this.selectedThemeSettings = InvoiceThemeService.mergeSettings({}, theme.settings);
            this.$emit("theme-selected", this.selectedThemeSettings);
            // this.$emit("settings-change", this.selectedThemeSettings)
        }
    }

    isThemeSelected(theme) {
        return (
            theme != null &&
            this.selectedThemeSettings?.name === (theme.settings?.name || theme.name)
        );
    }

    selectPreviewDocumentType(value) {
        debugger;
        this.selectedPreviewDocumentType = value;
        this.$emit("document-type-selected", value);
    }

    copyMainTableSettings() {
        let copied = false;
        if (this.invoiceThemeSettings?.vatTableBox?.automaticColors) {
            this.invoiceThemeSettings.vatTableBox.automaticColors =
                this.invoiceThemeSettings.mainTableBox.automaticColors;
            copied = true;
        }
        if (this.invoiceThemeSettings?.vatTableBox?.rows) {
            this.invoiceThemeSettings.vatTableBox.rows.secondaryBackgroundColor =
                this.invoiceThemeSettings.mainTableBox?.rows?.secondaryBackgroundColor;
            this.invoiceThemeSettings.vatTableBox.rows.mode =
                this.invoiceThemeSettings.mainTableBox?.rows?.mode;
            this.invoiceThemeSettings.vatTableBox.rows.borderColor =
                this.invoiceThemeSettings.tables?.rows?.borderColor;
            this.invoiceThemeSettings.vatTableBox.rows.border =
                this.invoiceThemeSettings.tables?.rows?.border;
            this.invoiceThemeSettings.vatTableBox.rows.backgroundColor =
                this.invoiceThemeSettings.tables?.rows?.backgroundColor;
            this.invoiceThemeSettings.vatTableBox.rows.color =
                this.invoiceThemeSettings.tables?.rows?.color;

            copied = true;
        }
        if (this.invoiceThemeSettings?.vatTableBox?.header) {
            this.invoiceThemeSettings.vatTableBox.header.backgroundColor =
                this.invoiceThemeSettings.tables?.header?.backgroundColor;
            this.invoiceThemeSettings.vatTableBox.header.color =
                this.invoiceThemeSettings.mainTableBox?.header?.color;

            copied = true;
        }
        if (this.invoiceThemeSettings?.vatTableBox?.rows) {
            this.invoiceThemeSettings.vatTableBox.rows.color =
                this.invoiceThemeSettings.mainTableBox?.rows?.color;

            copied = true;
        }
        if (
            this.invoiceThemeSettings?.vatTableBox?.style &&
            this.invoiceThemeSettings?.mainTableBox?.style
        ) {
            // _.assign(this.invoiceThemeSettings?.vatTableBox?.style, this.invoiceThemeSettings?.mainTableBox?.style)
            this.invoiceThemeSettings.vatTableBox.style.borderRadius = Math.min(
                this.vatTableBorderRadiusMax,
                this.invoiceThemeSettings.mainTableBox.style.borderRadius,
            );
        }

        if (copied) {
            this.tableConfCopySnackBar = true;
        }
    }

    handleInvoiceNumberCheckBoxChange(val) {
        // titleBox and invoiceNumberBox can not be selected together
        this.invoiceThemeSettings.page.repeatOnFollowingPages.titleBox = !val;
    }

    handleTitleCheckBoxChange(val) {
        // titleBox and invoiceNumberBox can not be selected together
        this.invoiceThemeSettings.page.repeatOnFollowingPages.invoiceNumberBox = !val;
    }
}

export default toNative(ExportThemeMenu);
</script>
<style scoped>
.ghost {
    background-color: rgba(249, 177, 42, 0.2);
}

:deep(.v-expansion-panel-content__wrap) {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.text-small {
    font-size: small;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}
</style>
